import { EncryptService } from "./../../services/encrypt.service";
import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ExcelService } from "src/app/services/excelservice/excel.service";
import { JoineeService } from "src/app/services/joinee.service";
import { SpinnerService } from "src/app/services/spinner.service";
import { environment } from "../../../environments/environment";
import { Router } from "@angular/router";
import { BsDatepickerConfig } from "ngx-bootstrap";
import { utf8Encode } from "@angular/compiler/src/util";
import { AlertService } from "src/app/services/alert.service";

@Component({
  selector: "app-view-application",
  templateUrl: "./view-application.component.html",
  styleUrls: ["./view-application.component.css"],
})
export class ViewApplicationComponent implements OnInit {
  datas: any[];
  viewApplication: FormGroup;
  documentData: string;
  recordSize: any = 100;
  previousPage: any = 0;
  pagesizeIncrease: any = 100;
  p: number = 1;
  l: number = 1;
  itemsPerPage: number = 5;

  MinDate: Date;
  MaxDate: Date;
  MaxDateEnd: Date;
  MinDateEnd: Date;

  bsDatepickerConfig: Partial<BsDatepickerConfig> = {};

  navApiUrl: any = environment.navApiUrl;

  list: any = [
    "Marketing",
    "Underwriting",
    "Claims",
    "Finance & Accounts",
    "IT",
    "Legal",
    "Actuary",
    "Other",
  ];

  locationMaster: any = [
    [
        "Agra",
        "Uttar Pradesh"
    ],
    [
        "Ahmedabad",
        "Gujarat"
    ],
    [
        "Ahmednagar",
        "Maharashtra"
    ],
    [
        "Aizawl",
        "Mizoram"
    ],
    [
        "Ajmer",
        "Rajasthan"
    ],
    [
        "Akola",
        "Maharashtra"
    ],
    [
        "Alipurduar",
        "West Bengal"
    ],
    [
        "Allahabad",
        "Uttar Pradesh"
    ],
    [
        "Alwar",
        "Rajasthan"
    ],
    [
        "Amalapuram",
        "Andhra Pradesh"
    ],
    [
        "Ambala",
        "Haryana"
    ],
    [
        "Ambikapur",
        "Chhattisgarh"
    ],
    [
        "Amethi",
        "Uttar Pradesh"
    ],
    [
        "Amravati",
        "Maharashtra"
    ],
    [
        "Amritsar",
        "Punjab"
    ],
    [
        "Anand",
        "Gujarat"
    ],
    [
        "Anandpur",
        "Odisha"
    ],
    [
        "Anantapur",
        "Andhra Pradesh"
    ],
    [
        "Anantnag",
        "Jammu & Kashmir"
    ],
    [
        "Angul",
        "Odisha"
    ],
    [
        "Ankleshwar",
        "Gujarat"
    ],
    [
        "Anna Nagar",
        "Tamil Nadu"
    ],
    [
        "Ashoknagar",
        "Madhya Pradesh"
    ],
    [
        "Athagarh",
        "Odisha"
    ],
    [
        "Aurangabad",
        "Maharashtra"
    ],
    [
        "Avinashi",
        "Tamil Nadu"
    ],
    [
        "Bagalkote",
        "Karnataka"
    ],
    [
        "Baikunthpur",
        "Chhattisgarh"
    ],
    [
        "Balaghat",
        "Madhya Pradesh"
    ],
    [
        "Balasore",
        "Odisha"
    ],
    [
        "Bangalore",
        "Karnataka"
    ],
    [
        "Bankura",
        "West Bengal"
    ],
    [
        "Banswara",
        "Rajasthan"
    ],
    [
        "Banur",
        "Punjab"
    ],
    [
        "Bapunagar",
        "Gujarat"
    ],
    [
        "Bardoli",
        "Gujarat"
    ],
    [
        "Bareilly",
        "Uttar Pradesh"
    ],
    [
        "Baripada",
        "Odisha"
    ],
    [
        "Barmer",
        "Rajasthan"
    ],
    [
        "Barnagar",
        "Madhya Pradesh"
    ],
    [
        "Barrackpore",
        "West Bengal"
    ],
    [
        "Baruipur",
        "West Bengal"
    ],
    [
        "Basirhat",
        "West Bengal"
    ],
    [
        "Bassi",
        "Rajasthan"
    ],
    [
        "Belgaum",
        "Karnataka"
    ],
    [
        "Bellary",
        "Karnataka"
    ],
    [
        "Berhampore",
        "West Bengal"
    ],
    [
        "Berhampur",
        "Odisha"
    ],
    [
        "Betma",
        "Madhya Pradesh"
    ],
    [
        "Betul",
        "Madhya Pradesh"
    ],
    [
        "Bhadrak",
        "Odisha"
    ],
    [
        "Bhagalpur",
        "Bihar"
    ],
    [
        "Bhandara ",
        "Maharashtra"
    ],
    [
        "Bhanpura",
        "Madhya Pradesh"
    ],
    [
        "Bharatpur",
        "Rajasthan"
    ],
    [
        "Bharuch",
        "Gujarat"
    ],
    [
        "Bhatinda",
        "Punjab"
    ],
    [
        "Bhavnagar",
        "Gujarat"
    ],
    [
        "Bhilai",
        "Chhattisgarh"
    ],
    [
        "Bhilwara",
        "Rajasthan"
    ],
    [
        "Bhimavaram ",
        "Andhra Pradesh"
    ],
    [
        "Bhind",
        "Madhya Pradesh"
    ],
    [
        "Bhinmal",
        "Rajasthan"
    ],
    [
        "Bhiwadi",
        "Rajasthan"
    ],
    [
        "Bhopal",
        "Madhya Pradesh"
    ],
    [
        "Bhubaneshwar",
        "Odisha"
    ],
    [
        "Bhuj",
        "Gujarat"
    ],
    [
        "Biaora",
        "Madhya Pradesh"
    ],
    [
        "Bidar",
        "Karnataka"
    ],
    [
        "Bijapur",
        "Karnataka"
    ],
    [
        "Bijolia",
        "Rajasthan"
    ],
    [
        "Bikaner",
        "Rajasthan"
    ],
    [
        "Bilaspur",
        "Chhattisgarh"
    ],
    [
        "Bilimora",
        "Gujarat"
    ],
    [
        "Birur",
        "Karnataka"
    ],
    [
        "Boisar",
        "Maharashtra"
    ],
    [
        "Bolangir",
        "Odisha"
    ],
    [
        "Borsad",
        "Gujarat"
    ],
    [
        "Botad",
        "Gujarat"
    ],
    [
        "Bundi",
        "Rajasthan"
    ],
    [
        "Burdwan",
        "West Bengal"
    ],
    [
        "Burhanpur",
        "Madhya Pradesh"
    ],
    [
        "Chamba",
        "Himachal Pradesh"
    ],
    [
        "Chandigarh",
        "Chandigarh"
    ],
    [
        "Chandigarh",
        "Punjab"
    ],
    [
        "Chandikhol",
        "Odisha"
    ],
    [
        "Chandrapur",
        "Maharashtra"
    ],
    [
        "Channagiri",
        "Karnataka"
    ],
    [
        "Chattarpur",
        "Madhya Pradesh"
    ],
    [
        "Chennai",
        "Tamil Nadu"
    ],
    [
        "Chikhli",
        "Gujarat"
    ],
    [
        "Chikkabalapur",
        "Karnataka"
    ],
    [
        "Chikmagalur",
        "Karnataka"
    ],
    [
        "Chikodi",
        "Karnataka"
    ],
    [
        "Chindwara",
        "Madhya Pradesh"
    ],
    [
        "Chintamani",
        "Karnataka"
    ],
    [
        "Chitradurga",
        "Karnataka"
    ],
    [
        "Chittoor",
        "Andhra Pradesh"
    ],
    [
        "Chittorgarh",
        "Rajasthan"
    ],
    [
        "Chomu",
        "Rajasthan"
    ],
    [
        "Churu",
        "Rajasthan"
    ],
    [
        "Coimbatore",
        "Tamil Nadu"
    ],
    [
        "Coochbehar",
        "West Bengal"
    ],
    [
        "Cuddalore",
        "Tamil Nadu"
    ],
    [
        "Cuddapah",
        "Andhra Pradesh"
    ],
    [
        "Cuttack",
        "Odisha"
    ],
    [
        "Dabhoi",
        "Gujarat"
    ],
    [
        "Dahod",
        "Gujarat"
    ],
    [
        "Damoh",
        "Madhya Pradesh"
    ],
    [
        "Darbhanga",
        "Bihar"
    ],
    [
        "Datia",
        "Madhya Pradesh"
    ],
    [
        "Dausa",
        "Rajasthan"
    ],
    [
        "Davangere",
        "Karnataka"
    ],
    [
        "Deesa",
        "Gujarat"
    ],
    [
        "Dehgam",
        "Gujarat"
    ],
    [
        "Dehradun",
        "Uttarakhand"
    ],
    [
        "Dera Bassi",
        "Punjab"
    ],
    [
        "Devanahalli",
        "Karnataka"
    ],
    [
        "Dewas",
        "Madhya Pradesh"
    ],
    [
        "Dhamtari",
        "Chhattisgarh"
    ],
    [
        "Dhanbad",
        "Jharkhand"
    ],
    [
        "Dhar",
        "Madhya Pradesh"
    ],
    [
        "Dhar (Jaora)",
        "Madhya Pradesh"
    ],
    [
        "Dharamshala",
        "Himachal Pradesh"
    ],
    [
        "Dhenkanal",
        "Odisha"
    ],
    [
        "Dhoraji",
        "Gujarat"
    ],
    [
        "Dhule",
        "Maharashtra"
    ],
    [
        "Dibrugarh",
        "Assam"
    ],
    [
        "Dindigul",
        "Tamil Nadu"
    ],
    [
        "Dindori",
        "Madhya Pradesh"
    ],
    [
        "Dungarpur",
        "Rajasthan"
    ],
    [
        "Durgapur",
        "West Bengal"
    ],
    [
        "Dwarka",
        "Gujarat"
    ],
    [
        "Elluru",
        "Andhra Pradesh"
    ],
    [
        "Erode",
        "Tamil Nadu"
    ],
    [
        "Faizabad",
        "Uttar Pradesh"
    ],
    [
        "Faridabad",
        "Haryana"
    ],
    [
        "Fatehabad",
        "Haryana"
    ],
    [
        "Fatehpur",
        "Uttar Pradesh"
    ],
    [
        "Firozabad",
        "Uttar Pradesh"
    ],
    [
        "Gadag",
        "Karnataka"
    ],
    [
        "Gadchiorli",
        "Maharashtra"
    ],
    [
        "Gajapati",
        "Odisha"
    ],
    [
        "Gandhidham",
        "Gujarat"
    ],
    [
        "Gandhinagar",
        "Gujarat"
    ],
    [
        "Gangtok",
        "Sikkim"
    ],
    [
        "Ganjam",
        "Odisha"
    ],
    [
        "Goa",
        "Goa"
    ],
    [
        "Gobichettipalayam",
        "Tamil Nadu"
    ],
    [
        "Godhra",
        "Gujarat"
    ],
    [
        "Gokak",
        "Karnataka"
    ],
    [
        "Gondal",
        "Gujarat"
    ],
    [
        "Gondia ",
        "Maharashtra"
    ],
    [
        "Gorakhpur",
        "Uttar Pradesh"
    ],
    [
        "Gulbarga",
        "Karnataka"
    ],
    [
        "Gummidipoondi",
        "Tamil Nadu"
    ],
    [
        "Guna",
        "Madhya Pradesh"
    ],
    [
        "Guntur",
        "Andhra Pradesh"
    ],
    [
        "Gurgaon",
        "Haryana "
    ],
    [
        "Gurugram",
        "Haryana"
    ],
    [
        "Guwahati",
        "Assam"
    ],
    [
        "Gwalior",
        "Madhya Pradesh"
    ],
    [
        "Haldia",
        "West Bengal"
    ],
    [
        "Haldwani",
        "Uttarakhand"
    ],
    [
        "Halol",
        "Gujarat"
    ],
    [
        "Hamirpur",
        "Himachal Pradesh"
    ],
    [
        "Hanumangarh",
        "Rajasthan"
    ],
    [
        "Hapur",
        "Uttar Pradesh"
    ],
    [
        "Harda",
        "Madhya Pradesh"
    ],
    [
        "Hassan",
        "Karnataka"
    ],
    [
        "Hathras",
        "Uttar Pradesh"
    ],
    [
        "Haveri",
        "Karnataka"
    ],
    [
        "Hayathnagar",
        "Telangana"
    ],
    [
        "Hazaribagh",
        "Jharkhand"
    ],
    [
        "Himmatnagar",
        "Gujarat"
    ],
    [
        "Hiriyur",
        "Karnataka"
    ],
    [
        "Hisar",
        "Haryana"
    ],
    [
        "Hoshangabad",
        "Madhya Pradesh"
    ],
    [
        "Hoshiarpur",
        "Punjab"
    ],
    [
        "Hoskote",
        "Karnataka"
    ],
    [
        "Hospet",
        "Karnataka"
    ],
    [
        "Hosur",
        "Tamil Nadu"
    ],
    [
        "Hubli",
        "Karnataka"
    ],
    [
        "Hyderabad",
        "Hyderabad"
    ],
    [
        "Hyderabad",
        "Telangana"
    ],
    [
        "Idar",
        "Gujarat"
    ],
    [
        "Imphal",
        "Manipur"
    ],
    [
        "Indore",
        "Madhya Pradesh"
    ],
    [
        "Jabalpur",
        "Madhya Pradesh"
    ],
    [
        "Jagdalpur",
        "Chhattisgarh"
    ],
    [
        "Jagraon",
        "Punjab"
    ],
    [
        "Jaipur",
        "Rajasthan"
    ],
    [
        "Jajpur",
        "Odisha"
    ],
    [
        "Jalandhar",
        "Punjab"
    ],
    [
        "Jalgaon",
        "Maharashtra"
    ],
    [
        "Jalore",
        "Rajasthan"
    ],
    [
        "Jamkhandi",
        "Karnataka"
    ],
    [
        "Jammu",
        "Jammu & Kashmir"
    ],
    [
        "Jamnagar",
        "Gujarat"
    ],
    [
        "Jamshedpur",
        "Jharkhand"
    ],
    [
        "Janjgir Champa",
        "Chhattisgarh"
    ],
    [
        "Japanese",
        "Haryana"
    ],
    [
        "Jeypore",
        "Odisha"
    ],
    [
        "Jhajjar",
        "Haryana"
    ],
    [
        "Jhalawar",
        "Rajasthan"
    ],
    [
        "Jhalod",
        "Gujarat"
    ],
    [
        "Jhansi",
        "Uttar Pradesh"
    ],
    [
        "Jhunjhunu",
        "Rajasthan"
    ],
    [
        "Jodhpur",
        "Rajasthan"
    ],
    [
        "Jorhat",
        "Assam"
    ],
    [
        "Junagarh",
        "Gujarat"
    ],
    [
        "Kadi",
        "Gujarat"
    ],
    [
        "Kaithal",
        "Haryana"
    ],
    [
        "Kakinada",
        "Andhra Pradesh"
    ],
    [
        "Kala Amb",
        "Himachal Pradesh"
    ],
    [
        "Kalol",
        "Gujarat"
    ],
    [
        "Kalyan",
        "Maharashtra"
    ],
    [
        "Kamrej",
        "Gujarat"
    ],
    [
        "Kancheepuram",
        "Tamil Nadu"
    ],
    [
        "Kanpur",
        "Uttar Pradesh"
    ],
    [
        "Karaikudi",
        "Tamil Nadu"
    ],
    [
        "Karimnagar",
        "Telangana"
    ],
    [
        "Karnal",
        "Haryana"
    ],
    [
        "Karur",
        "Tamil Nadu"
    ],
    [
        "Kashipur ",
        "Uttarakhand"
    ],
    [
        "Kathua",
        "Jammu & Kashmir"
    ],
    [
        "Katni",
        "Madhya Pradesh"
    ],
    [
        "Kawardha",
        "Chhattisgarh"
    ],
    [
        "Kawas",
        "Gujarat"
    ],
    [
        "Kendrapara",
        "Odisha"
    ],
    [
        "Keonjhar",
        "Odisha"
    ],
    [
        "Khambhat",
        "Gujarat"
    ],
    [
        "Khamgaon",
        "Maharashtra"
    ],
    [
        "Khammam",
        "Telangana"
    ],
    [
        "Khandwa",
        "Madhya Pradesh"
    ],
    [
        "Kharagpur",
        "West Bengal"
    ],
    [
        "Kharar",
        "Punjab"
    ],
    [
        "Khargone",
        "Madhya Pradesh"
    ],
    [
        "Kheralu",
        "Gujarat"
    ],
    [
        "Khurda",
        "Odisha"
    ],
    [
        "Kim",
        "Gujarat"
    ],
    [
        "Kochi",
        "Kerala"
    ],
    [
        "Kodad",
        "Telangana"
    ],
    [
        "Kolar",
        "Karnataka"
    ],
    [
        "Kolhapur",
        "Maharashtra"
    ],
    [
        "Kolkata",
        "West Bengal"
    ],
    [
        "Kota",
        "Rajasthan"
    ],
    [
        "Kottayam",
        "Kerala"
    ],
    [
        "Kozhikode",
        "Kerala"
    ],
    [
        "Krishnanagar",
        "West Bengal"
    ],
    [
        "Kullu",
        "Himachal Pradesh"
    ],
    [
        "Kumbakonam",
        "Tamil Nadu"
    ],
    [
        "Kurnool",
        "Andhra Pradesh"
    ],
    [
        "Latur",
        "Maharashtra"
    ],
    [
        "Lucknow",
        "Uttar Pradesh"
    ],
    [
        "Ludhiana",
        "Punjab"
    ],
    [
        "Lunawada",
        "Gujarat"
    ],
    [
        "Madhugiri",
        "Karnataka"
    ],
    [
        "Madurai",
        "Tamil Nadu"
    ],
    [
        "Mahed",
        "Maharashtra"
    ],
    [
        "Mahoba",
        "Uttar Pradesh"
    ],
    [
        "Maihar",
        "Madhya Pradesh"
    ],
    [
        "Malda",
        "West Bengal"
    ],
    [
        "Malegaon",
        "Maharashtra"
    ],
    [
        "Malihabad",
        "Uttar Pradesh"
    ],
    [
        "Malkangiri",
        "Odisha"
    ],
    [
        "Malur",
        "Karnataka"
    ],
    [
        "Mancherial",
        "Telangana"
    ],
    [
        "Mandi",
        "Himachal Pradesh"
    ],
    [
        "Mandla",
        "Madhya Pradesh"
    ],
    [
        "Mandsaur",
        "Madhya Pradesh"
    ],
    [
        "Mandya",
        "Karnataka"
    ],
    [
        "Mangalore",
        "Karnataka"
    ],
    [
        "Margao",
        "Goa"
    ],
    [
        "Mass",
        "Haryana"
    ],
    [
        "Mathura",
        "Uttar Pradesh"
    ],
    [
        "Meerut",
        "Uttar Pradesh"
    ],
    [
        "Mehsana",
        "Gujarat"
    ],
    [
        "Modasa",
        "Gujarat"
    ],
    [
        "Moga",
        "Punjab"
    ],
    [
        "Morbi",
        "Gujarat"
    ],
    [
        "Mumbai",
        "Maharashtra"
    ],
    [
        "Mundra",
        "Gujarat"
    ],
    [
        "Mungeli",
        "Chhattisgarh"
    ],
    [
        "Murbad",
        "Maharashtra"
    ],
    [
        "Muzaffarpur",
        "Bihar"
    ],
    [
        "Muzzafarnagar",
        "Uttar Pradesh"
    ],
    [
        "Mysore",
        "Karnataka"
    ],
    [
        "Nabha",
        "Punjab"
    ],
    [
        "Nadiad",
        "Gujarat"
    ],
    [
        "Nagaon",
        "Assam"
    ],
    [
        "Nagda",
        "Madhya Pradesh"
    ],
    [
        "Nagercoil",
        "Tamil Nadu"
    ],
    [
        "Nagpur",
        "Maharashtra"
    ],
    [
        "Naharlagun",
        "Arunachal Pradesh"
    ],
    [
        "Nalagarh",
        "Himachal Pradesh"
    ],
    [
        "Nalgonda",
        "Telangana"
    ],
    [
        "Namakkal",
        "Tamil Nadu"
    ],
    [
        "Nan Pondha",
        "Gujarat"
    ],
    [
        "Nanded",
        "Maharashtra"
    ],
    [
        "Narasaraopet",
        "Andhra Pradesh"
    ],
    [
        "Narsampet",
        "Telangana"
    ],
    [
        "Narsinghgarh",
        "Madhya Pradesh"
    ],
    [
        "Narsinghpur",
        "Madhya Pradesh"
    ],
    [
        "Nasik",
        "Maharashtra"
    ],
    [
        "Nasrullaganj",
        "Madhya Pradesh"
    ],
    [
        "Navsari",
        "Gujarat"
    ],
    [
        "Nayagarh",
        "Odisha"
    ],
    [
        "Neemuch",
        "Madhya Pradesh"
    ],
    [
        "Nelamangala",
        "Karnataka"
    ],
    [
        "Nellore",
        "Andhra Pradesh"
    ],
    [
        "New Delhi",
        "New Delhi"
    ],
    [
        "Nizamabad",
        "Telangana"
    ],
    [
        "Noida",
        "Uttar Pradesh"
    ],
    [
        "Ongole",
        "Andhra Pradesh"
    ],
    [
        "Palanpur",
        "Gujarat"
    ],
    [
        "Pali",
        "Rajasthan"
    ],
    [
        "Panna",
        "Madhya Pradesh"
    ],
    [
        "Panvel",
        "Maharashtra"
    ],
    [
        "Paonta Sahib",
        "Himachal Pradesh"
    ],
    [
        "Paradeep",
        "Odisha"
    ],
    [
        "Patan",
        "Gujarat"
    ],
    [
        "Pataudi",
        "Haryana"
    ],
    [
        "Patia  ",
        "Odisha"
    ],
    [
        "Patiala",
        "Punjab"
    ],
    [
        "Patna",
        "Bihar"
    ],
    [
        "Peddapally",
        "Telangana"
    ],
    [
        "Pehowa",
        "Haryana"
    ],
    [
        "Perambalur",
        "Tamil Nadu"
    ],
    [
        "Perintalmanna",
        "Kerala"
    ],
    [
        "Phulbani",
        "Odisha"
    ],
    [
        "Pithampur",
        "Madhya Pradesh"
    ],
    [
        "Pithoragarh",
        "Uttarakhand"
    ],
    [
        "Pollachi",
        "Tamil Nadu"
    ],
    [
        "Pondicherry",
        "Pondicherry"
    ],
    [
        "Porbandar",
        "Gujarat"
    ],
    [
        "Porur",
        "Tamil Nadu"
    ],
    [
        "Produttur",
        "Andhra Pradesh"
    ],
    [
        "Pune",
        "Maharashtra"
    ],
    [
        "Puri",
        "Odisha"
    ],
    [
        "Purnia",
        "Bihar"
    ],
    [
        "Puttur",
        "Andhra Pradesh"
    ],
    [
        "Puttur",
        "Karnataka"
    ],
    [
        "Raebareli",
        "Uttar Pradesh"
    ],
    [
        "Raichur",
        "Karnataka"
    ],
    [
        "Raiganj",
        "West Bengal"
    ],
    [
        "Raigarh",
        "Chhattisgarh"
    ],
    [
        "Raipur",
        "Chhattisgarh"
    ],
    [
        "Rairangpur",
        "Odisha"
    ],
    [
        "Raisen",
        "Madhya Pradesh"
    ],
    [
        "Rajahmundry",
        "Andhra Pradesh"
    ],
    [
        "Rajkot",
        "Gujarat"
    ],
    [
        "Rajnandgaon",
        "Chhattisgarh"
    ],
    [
        "Rajpura",
        "Punjab"
    ],
    [
        "Rajsamand",
        "Rajasthan"
    ],
    [
        "Ramanagara ",
        "Karnataka"
    ],
    [
        "Ranchi",
        "Jharkhand"
    ],
    [
        "Ratlam",
        "Madhya Pradesh"
    ],
    [
        "Ratnagiri",
        "Maharashtra"
    ],
    [
        "Rau",
        "Madhya Pradesh"
    ],
    [
        "Rayadga",
        "Odisha"
    ],
    [
        "Rewa",
        "Madhya Pradesh"
    ],
    [
        "Rewari",
        "Haryana"
    ],
    [
        "Robertsganj",
        "Uttar Pradesh"
    ],
    [
        "Rohtak",
        "Haryana"
    ],
    [
        "Roorkee",
        "Uttarakhand"
    ],
    [
        "Ropar",
        "Punjab"
    ],
    [
        "Rourkela",
        "Odisha"
    ],
    [
        "Sagar",
        "Karnataka"
    ],
    [
        "Sagar",
        "Madhya Pradesh"
    ],
    [
        "Salem",
        "Tamil Nadu"
    ],
    [
        "Sambalpur",
        "Odisha"
    ],
    [
        "Sanand",
        "Gujarat"
    ],
    [
        "Sanathnagar",
        "Telangana"
    ],
    [
        "Sanawad",
        "Madhya Pradesh"
    ],
    [
        "Sangareddy",
        "Telangana"
    ],
    [
        "Sangli",
        "Maharashtra"
    ],
    [
        "Sangrur",
        "Punjab"
    ],
    [
        "Satara",
        "Maharashtra"
    ],
    [
        "Satna",
        "Madhya Pradesh"
    ],
    [
        "Secundrabad",
        "Telangana"
    ],
    [
        "Sehore",
        "Madhya Pradesh"
    ],
    [
        "Seoni",
        "Madhya Pradesh"
    ],
    [
        "Shahdol",
        "Madhya Pradesh"
    ],
    [
        "Shahjahanpur ",
        "Uttar Pradesh"
    ],
    [
        "Shajapur",
        "Madhya Pradesh"
    ],
    [
        "Sheopur",
        "Madhya Pradesh"
    ],
    [
        "Shillong",
        "Meghalaya"
    ],
    [
        "Shimla",
        "Himachal Pradesh"
    ],
    [
        "Shimoga",
        "Karnataka"
    ],
    [
        "Shirpur-Dhule",
        "Maharashtra"
    ],
    [
        "Shivpuri",
        "Madhya Pradesh"
    ],
    [
        "Sholapur",
        "Maharashtra"
    ],
    [
        "Shujalpur",
        "Madhya Pradesh"
    ],
    [
        "Siddhpur",
        "Gujarat"
    ],
    [
        "Siddipet",
        "Telangana"
    ],
    [
        "Sidhi",
        "Madhya Pradesh"
    ],
    [
        "Sikar",
        "Rajasthan"
    ],
    [
        "Siliguri",
        "West Bengal"
    ],
    [
        "Silvassa",
        "Dadra &  Nagar Haveli "
    ],
    [
        "Singrauli",
        "Madhya Pradesh"
    ],
    [
        "Sirhind",
        "Punjab"
    ],
    [
        "Sirsi",
        "Karnataka"
    ],
    [
        "Sitamau",
        "Madhya Pradesh"
    ],
    [
        "Solan",
        "Himachal Pradesh"
    ],
    [
        "Sonipat",
        "Haryana"
    ],
    [
        "Sopore",
        "Jammu & Kashmir"
    ],
    [
        "Sri Ganganagar",
        "Rajasthan"
    ],
    [
        "Srikakulam",
        "Andhra Pradesh"
    ],
    [
        "Srinagar",
        "Jammu & Kashmir"
    ],
    [
        "Sundarnagar",
        "Himachal Pradesh"
    ],
    [
        "Sundergarh",
        "Odisha"
    ],
    [
        "Surat",
        "Gujarat"
    ],
    [
        "Tambaram",
        "Tamil Nadu"
    ],
    [
        "Tarakeswar",
        "West Bengal"
    ],
    [
        "Tarn Taran EBK",
        "Punjab"
    ],
    [
        "Theni",
        "Tamil Nadu"
    ],
    [
        "Thrissur",
        "Kerala"
    ],
    [
        "Tikamgarh",
        "Madhya Pradesh"
    ],
    [
        "Tirunelveli",
        "Tamil Nadu"
    ],
    [
        "Tirupati",
        "Andhra Pradesh"
    ],
    [
        "Tirupur",
        "Tamil Nadu"
    ],
    [
        "Tohana",
        "Haryana"
    ],
    [
        "Tonk",
        "Rajasthan"
    ],
    [
        "Trichy",
        "Tamil Nadu"
    ],
    [
        "Tripura West",
        "Tripura"
    ],
    [
        "Trivandrum",
        "Kerala"
    ],
    [
        "Tumkur",
        "Karnataka"
    ],
    [
        "Tuticorin",
        "Tamil Nadu"
    ],
    [
        "Udaipur",
        "Rajasthan"
    ],
    [
        "Udhampur",
        "Jammu & Kashmir"
    ],
    [
        "Udupi",
        "Karnataka"
    ],
    [
        "Ujjain",
        "Madhya Pradesh"
    ],
    [
        "Umarkote",
        "Odisha"
    ],
    [
        "Umergaon",
        "Gujarat"
    ],
    [
        "Umreth",
        "Gujarat"
    ],
    [
        "Una",
        "Gujarat"
    ],
    [
        "Una",
        "Himachal Pradesh"
    ],
    [
        "Vadodara",
        "Gujarat"
    ],
    [
        "Valsad",
        "Gujarat"
    ],
    [
        "Vapi",
        "Gujarat"
    ],
    [
        "Varanasi",
        "Uttar Pradesh"
    ],
    [
        "Vasai",
        "Maharashtra"
    ],
    [
        "Vasco Da Gama",
        "Goa "
    ],
    [
        "Vellore",
        "Tamil Nadu"
    ],
    [
        "Veraval",
        "Gujarat"
    ],
    [
        "Vidisha",
        "Madhya Pradesh"
    ],
    [
        "Vijapur",
        "Gujarat"
    ],
    [
        "Vijayawada",
        "Andhra Pradesh"
    ],
    [
        "Visakapatanam",
        "Andhra Pradesh"
    ],
    [
        "Vizianagaram",
        "Andhra Pradesh"
    ],
    [
        "Vsanda",
        "Gujarat"
    ],
    [
        "Vyara",
        "Gujarat"
    ],
    [
        "Waragal",
        "Telangana"
    ],
    [
        "Warangal",
        "Telangana"
    ],
    [
        "Wardha",
        "Maharashtra"
    ],
    [
        "Yalhanka",
        "Karnataka"
    ],
    [
        "Yamunanagar",
        "Haryana"
    ],
    [
        "Yavatmal",
        "Maharashtra"
    ]
];

  constructor(
    private formBuilder: FormBuilder,
    private spinner: SpinnerService,
    private joineeService: JoineeService,
    public datepipe: DatePipe,
    private excelService: ExcelService,
    private router: Router,
    private encryptService: EncryptService,
    private alertService: AlertService
  ) {
    this.bsDatepickerConfig.dateInputFormat = "DD/MM/YYYY";
    this.bsDatepickerConfig.containerClass = "theme-green";
    this.bsDatepickerConfig.showWeekNumbers = false;
    const startDate = new Date(new Date().setHours(0, 0, 0, 0));

    this.MinDate = new Date(startDate.getTime());
    // this.adultMinDOB.setFullYear(startDate.getFullYear() - Constants.PROPOSER_MINIMUM_AGE_LIMIT);
    this.MinDate.setFullYear(startDate.getFullYear() - 150);
    this.MaxDate = new Date(startDate.getTime());
    // this.adultMaxDOB.setFullYear(startDate.getFullYear() - Constants.PROPOSER_MAXIMUM_AGE_LIMIT);
    this.MaxDate.setFullYear(startDate.getFullYear() - 0);

    this.MaxDateEnd = this.MaxDate;

    // console.log(this.MinDate);

    this.MinDateEnd = this.MinDate;
  }

  ngOnInit(): void {
    let login = localStorage.getItem("login");
    login = this.encryptService.decryptData(login);
    if (login == "false") {
      this.router.navigate(["/login"]);
    }

    // this.getDetails();

    this.viewApplication = this.formBuilder.group({
      name: ["", []],
      mobile: ["", []],
      functionAppliedFor: ["", []],
      locationAppliedFor: ["", []],
      startDate: ["", []],
      endDate: ["", []],
    });

    this.f.startDate.valueChanges.subscribe((value) => {
      this.viewApplication.controls.endDate.reset();
      this.setMaxDate();
    });

    // this.list = this.joineeService.getFunctionMaster();

    // this.locationMaster = this.joineeService.getLocationMaster();
    this.locationMaster = this.locationMaster.map((item) => ({
      city: item[0],
      state: item[1],
    }));

    const date = new Date();
   

    const startDate = new Date(date);
    startDate.setDate(date.getDate() - 30);
    this.viewApplication.controls.startDate.setValue(startDate);
    this.viewApplication.controls.endDate.setValue(date);    

    this.onSubmit();
  }

  get f() {
    return this.viewApplication.controls;
  }

  Logout() {
    localStorage.setItem("login", this.encryptService.encryptData("false"));
    this.router.navigate(["/login"]);
  }

  setMaxDate() {
    this.MinDateEnd = new Date(this.viewApplication.controls.startDate.value);

    this.MaxDateEnd = new Date(this.viewApplication.controls.startDate.value);
    this.MaxDateEnd.setDate(this.MaxDateEnd.getDate() + 31);
  }

  onPageChange(currentPage) {
    let userData = JSON.parse(localStorage.getItem("Date"));
    if (currentPage < this.previousPage) {
      this.previousPage = currentPage;
      return;
    }
    this.recordSize = this.recordSize + this.pagesizeIncrease;
  }

  async getDetails() {
    let response = await this.joineeService.getNewJoineeList();
    this.datas = response;
  }

  async getDocument(data: any) {
    const documentDetails = await this.joineeService.getDocumentDeteails(data);

    const documentData = documentDetails[0];

    // console.log(documentData);

    // let url: any = URL.createObjectURL(documentData);
    const blob = this.b64toBlob(documentData);
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl, "_blank");
  }

  b64toBlob(b64Data, contentType = "application/pdf", sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  async onSubmit() {
    // debugger;
    this.spinner.showSpinner();

    // console.log(this.viewApplication);

    const payload = this.viewApplication.getRawValue();

    // console.log(payload);

    

    if(((payload.startDate != "" && payload.startDate != null) && (payload.endDate == "" || payload.endDate == null)) ||
    ((payload.startDate == "" || payload.startDate == null) && (payload.endDate != "" && payload.endDate != null))){
        this.alertService.error("Start Date and End Date Required");
        this.spinner.hideSpinner();
        return;
    }

    const request = {
        name: payload.name,
        mobileNumber: payload.mobile,
        function: payload.functionAppliedFor, 
        location: payload.locationAppliedFor,
        startDate: this.datepipe.transform(this.viewApplication.controls.startDate.value,"yyyy-MM-dd"),
        endDate: this.datepipe.transform(this.viewApplication.controls.endDate.value,"yyyy-MM-dd")
    }

    const response = await this.joineeService.getRequests(request);
    this.datas = response;

    
    this.spinner.hideSpinner();
  }

  exportToExcel() {
    var exportexcelData = [];
    const exportData = this.datas;
    for (var i = 0; i < exportData.length; i++) {
      let encryptData = this.encryptService.encryptData(exportData[i].id);
    //   console.log(encryptData);
      encryptData = utf8Encode(encryptData);
    //   console.log(encryptData);
      exportexcelData.push({
        ID: i + 1,
        NAME: exportData[i].name,
        AGE: exportData[i].age,
        MOBILE_NUMBER: exportData[i].mobileNumber,
        PRESENT_LOCATION: exportData[i].presentLocation,
        LOCATION_APPLIED_FOR: exportData[i].locationAppliedFor,
        PRESENT_FUNCTION: exportData[i].presentFunction,
        FUNCTION_APPLIED_FOR: exportData[i].functionAppliedFor,
        PRESENT_ORGANIZATION_NAME: exportData[i].presentOrganizationName,
        NOTICE_PERIOD_IN_PRESENT_ORGANIZATION:
          exportData[i].noticePeriodInpresentOrganization,
        PREVIOUSLY_WORK_WITH_IFFCO_TOKIO: exportData[i].previouslyWorkWithIFFCO,
        EXPERIENCE_IN_BFSI: exportData[i].experienceInBFSI,
        CURRENT_CTC: exportData[i].currentCtc,
        HIGHEST_QUALIFICATION: exportData[i].highestQualification,
        INSURANCE_QUALIFICATION: exportData[i].insuranceQualification,
        EMAIL_ID: exportData[i].emailId,
        EXPERIENCE_IN_INSURANCE_INDUSTRY:
          exportData[i].experienceInInsuranceIndustry,
        CV:
          '=HYPERLINK("https://career.iffcotokio.co.in/itgi-hiring/common/download/' +
          encryptData +
          '","' +
          exportData[i].attachedCvName +
          '")',
      });
    }
    this.excelService.exportAsExcelFile(
      exportexcelData,
      "Applied_Applications"
    );
  }

  onReset(){
    this.viewApplication.reset();
  }
}
